import Wizard from './Wizard.svelte'
import Step from './Step.svelte'

Wizard.Step = Step

export default Wizard